import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Placeholder cute/kawaii para estado sin conexión.
 * Usa la paleta del dashboard (purple/indigo) para mantener coherencia con la app.
 */
const SinConexionKawaii = ({
	height = "340px",
	fontFamily = "inherit",
	message = "Sin conexión",
	submessage = "El mapa se cargará cuando tengas conexión",
}) => {
	return (
		<Box
			sx={{
				width: "100%",
				height,
				position: "relative",
				zIndex: 2,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				background: "linear-gradient(165deg, #F8FAFC 0%, #EEF2FF 40%, #F5F3FF 100%)",
				borderRadius: "20px",
				border: "2px solid rgba(99, 102, 241, 0.15)",
				boxShadow: "inset 0 2px 20px rgba(99, 102, 241, 0.06), 0 4px 20px rgba(0,0,0,0.04)",
				overflow: "hidden",
			}}
		>
			{/* Decoración: círculos suaves de fondo */}
			<Box
				sx={{
					position: "absolute",
					top: "15%",
					left: "10%",
					width: 80,
					height: 80,
					borderRadius: "50%",
					background: "rgba(168, 85, 247, 0.08)",
				}}
			/>
			<Box
				sx={{
					position: "absolute",
					bottom: "20%",
					right: "8%",
					width: 100,
					height: 100,
					borderRadius: "50%",
					background: "rgba(99, 102, 241, 0.06)",
				}}
			/>

			{/* Ilustración kawaii: estrella del logo, tamaño ajustado y cerca del texto */}
			<Box
				sx={{
					position: "relative",
					mb: -0.75,
					"@keyframes float": {
						"0%, 100%": { transform: "translateY(0)" },
						"50%": { transform: "translateY(-6px)" },
					},
					animation: "float 3s ease-in-out infinite",
				}}
			>
				<svg
					width="72"
					height="60"
					viewBox="0 0 120 100"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden
				>
					<path
						d="M 53 40.3 Q 60 22 67 40.3 Q 86.6 41.3 71.4 53.8 Q 76.5 72.7 60 62 Q 43.5 72.7 48.6 53.8 Q 33.4 41.3 53 40.3 Z"
						fill="#FACC15"
						stroke="#EAB308"
						strokeWidth="1.5"
						strokeLinejoin="round"
					/>
					<path
						d="M 46 50 Q 50 55 54 50"
						stroke="#1a1a2e"
						strokeWidth="2"
						strokeLinecap="round"
						fill="none"
						style={{ transform: "scale(0.5) translate(59px, 45px)" }}
					/>
					<path
						d="M 66 50 Q 70 55 74 50"
						stroke="#1a1a2e"
						strokeWidth="2"
						strokeLinecap="round"
						fill="none"
						style={{ transform: "scale(0.5) translate(60px, 45px)" }}
					/>
					{/* Boca triste: mismo trazo que el ojo, girado 180° */}
					<path
						d="M 66 50 Q 70 55 74 50"
						stroke="#1a1a2e"
						strokeWidth="2"
						strokeLinecap="round"
						fill="none"
						style={{ transform: "scale(0.5) translate(190px, 156px) rotate(180deg)" }}
					/>
				</svg>
			</Box>

			<Typography
				variant="body1"
				sx={{
					fontFamily: `${fontFamily} !important`,
					fontSize: "1.1rem",
					fontWeight: 600,
					color: "#4F46E5",
					mb: 0.5,
				}}
			>
				{message}
			</Typography>
			<Typography
				variant="body2"
				sx={{
					fontFamily: `${fontFamily} !important`,
					fontSize: "0.8rem",
					color: "#64748B",
					maxWidth: 260,
					textAlign: "center",
				}}
			>
				{submessage}
			</Typography>
		</Box>
	);
};

export default SinConexionKawaii;
